import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component, Inject} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonOption, ButtonsProsegurComponent } from '../../shared/buttons-prosegur/buttons-prosegur.component';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatTooltipModule,
    MatCardModule,
    MatIconModule,
    TranslateModule,
    ButtonsProsegurComponent
  ],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.sass']
})
export class ConfirmationDialogComponent 
{
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
  myButtonOptions: ButtonOption[] = 
  [
    { label: 'Common.Confirm', action: () => this.dialogRef.close(true), disabled: new BehaviorSubject<boolean>(false) },
    { label: 'Common.Cancel', action: () => this.dialogRef.close(false), disabled: new BehaviorSubject<boolean>(false) },
  ];
}